import React, { useState, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
    Link,
    useLocation
} from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Container,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Box,
    useMediaQuery,
    CssBaseline,
    CircularProgress
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu'; // Import MenuIcon
import InboxIcon from '@mui/icons-material/MoveToInbox'; // Example Icon
import SettingsIcon from '@mui/icons-material/Settings'; // Example Icon
import VpnKeyIcon from '@mui/icons-material/VpnKey'; // Example Icon
import OfferPage from './components/OfferPage';
import ConfigPage from './components/ConfigPage';
import LoginPage from './components/LoginPage';
import { logout } from './api'; // Import logout
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ChangePasswordPage from './components/ChangePasswordPage';
import OtpVerificationPage from './components/OtpVerificationPage';
import LocationOnIcon from '@mui/icons-material/LocationOn'; // Import Location icon
import LocationsPage from './components/LocationsPage';
import DynamicFormPage from './components/DynamicFormPage';
import ManageReceipts from './components/ManageReceipts';
import ApiDocsSection from './components/ApiDocsSection';
import DownloadIcon from '@mui/icons-material/Download'; // Import the Download icon
import DownloadsPage from './components/DownloadsPage'; // Import the new page component

const drawerWidth = 250; // Define drawer width as a variable


function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false); // State for drawer
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md')); // Use the theme breakpoints
    const [authLoading, setAuthLoading] = useState(true); // New state for authentication loading
    // useEffect(() => {
    //     const token = localStorage.getItem('token');
    //     if (token) {
    //         setIsLoggedIn(true);
    //     }
    // }, []);

    useEffect(() => {
        const checkAuth = async () => {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    // const user = await getUserData(token);  // Replace getUserData with your actual API call

                    // // TODO
                    // // Check the /me API to validate the user and set the user data
                    //setUser(user);

                    setIsLoggedIn(true);
                } catch (error) {
                    console.error("Authentication check failed:", error);
                    localStorage.removeItem('token'); // Clear invalid token
                    setIsLoggedIn(false);
                }
            } else {
                setIsLoggedIn(false);
            }
            setAuthLoading(false); // Set authLoading to false when check is complete
        };

        checkAuth();
    }, []);

    const handleLogin = (token) => {
        localStorage.setItem('token', token);
        setIsLoggedIn(true);
    };

    const handleLogout = () => {
        logout();
        setIsLoggedIn(false);
    };

    // Protected Route Component
    const ProtectedRoute = ({ children }) => {
        const location = useLocation(); // Get current location
        // alert("protected route");
        if (!isLoggedIn) {
            return <Navigate to="/login" state={{ from: location.pathname }} />;
        }
        return children;
    };

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpenDrawer(open);
    };

    // Close drawer only on mobile when clicking a link
    const handleDrawerClose = () => {
        // alert("handledrawer "+isLoggedIn);
        if (!isDesktop && !isLoggedIn) {
            setOpenDrawer(false);
        }
    };

    const drawerList = (
        <Box
            sx={{ width: drawerWidth }} // Use the variable
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            {/* Optional: Add a logo or app title in the drawer header */}
            <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
                <Typography variant="h6">Handy Receipts</Typography>
            </Box>
            <List>
                {isLoggedIn ? (
                    <>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to="/locations">
                                <ListItemIcon>
                                    <LocationOnIcon /> {/* Use the Location icon */}
                                </ListItemIcon>
                                <ListItemText primary="Locations" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to="/">
                                <ListItemIcon>
                                    <InboxIcon /> {/* Replace with your icon */}
                                </ListItemIcon>
                                <ListItemText primary="Offers" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to="/config">
                                <ListItemIcon>
                                    <SettingsIcon /> {/* Replace with your icon */}
                                </ListItemIcon>
                                <ListItemText primary="Receipt Configuration" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to="/create-receipt">
                                <ListItemIcon>
                                    <SettingsIcon /> {/* Replace with your icon */}
                                </ListItemIcon>
                                <ListItemText primary="Create Receipts" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to="/manage-receipts">
                                <ListItemIcon>
                                    <SettingsIcon /> {/* Replace with your icon */}
                                </ListItemIcon>
                                <ListItemText primary="Manage Receipts" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton component={Link} to="/change-password">
                                <ListItemIcon>
                                    <VpnKeyIcon /> {/* Replace with your icon */}
                                </ListItemIcon>
                                <ListItemText primary="Change Password" />
                            </ListItemButton>
                        </ListItem>
                         
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to="/api-doc">
                                <ListItemIcon>
                                    <VpnKeyIcon /> 
                                </ListItemIcon>
                                <ListItemText primary="API Documentation" />
                            </ListItemButton>
                        </ListItem>
                         
                           <ListItem disablePadding>
                            <ListItemButton component={Link} to="/downloads">
                                <ListItemIcon>
                                    <DownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Downloads" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={handleLogout}>
                                <ListItemText primary="Logout" />
                            </ListItemButton>
                        </ListItem>
                    </>
                ) : (
                    <ListItem disablePadding>
                        <ListItemButton component={Link} to="/login">
                            <ListItemText primary="Login" />
                        </ListItemButton>
                    </ListItem>
                )}
            </List>
        </Box>
    );



    return (
        <Router>
            {authLoading ? (
                // Show loading indicator while checking auth
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <CircularProgress /> {/* Use a Material UI loading spinner */}
                </Box>
            ) : (
                <Box sx={{ display: 'flex' }}>
                    <CssBaseline /> {/* Apply CssBaseline */}
                    {isLoggedIn && (
                        <>
                            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}> {/* AppBar above drawer */}
                                <Toolbar>
                                    
                                        <IconButton
                                            size="large"
                                            edge="start"
                                            color="inherit"
                                            aria-label="menu"
                                            sx={{ mr: 2 }}
                                            onClick={toggleDrawer(true)}
                                        >
                                            <MenuIcon />
                                        </IconButton>
                                    
                                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                                        Admin Panel
                                    </Typography>
                                    {/* Login/Logout button can remain here or move to drawer */}
                                    {!isDesktop && (
                                        <Button color="inherit" onClick={handleLogout} > {/* Show logout on mobile appbar */}
                                            Logout
                                        </Button>
                                    )}
                                </Toolbar>
                            </AppBar>
                            <Drawer
                                variant="temporary"  // Make drawer temporary always
                                open={openDrawer}    // Open when set to true
                                onClose={toggleDrawer(false)} // Close when toggled off
                                ModalProps={{
                                    keepMounted: true,  // Keep drawer mounted for smoother opening
                                }}
                                sx={{
                                    width: drawerWidth,
                                    flexShrink: 0,
                                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', pt: '64px' }, // Adjust padding for app bar
                                    // display: isLoggedIn ? 'block' : 'none', // Hide drawer completely when logged out
                                }}
                            >
                                {drawerList}
                            </Drawer>
                        </>
                    )}
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            p: 3,
                            mt: '32px', // Margin top for app bar height
                            ml: isLoggedIn && isDesktop ? '10px' : 0, // Margin left if drawer is permanent and logged in
                            transition: theme => theme.transitions.create('margin', { // Optional: Add transition for smoother layout change
                                easing: theme.transitions.easing.sharp,
                                duration: theme.transitions.duration.leavingScreen,
                            }),
                            width: '100%' // Take up full width since the drawer is hidden

                            //   width: { sm: `calc(100% - ${drawerWidth}px)` } // Added width calculation for better responsiveness

                        }}
                    >
                        <Routes>
                            {/* Redirect root to /login if not logged in */}
                            {/* <Route path="/" element={isLoggedIn ? <Navigate to="/" /> : <Navigate to="/login" />} /> */}
                            <Route path="/login" element={isLoggedIn ? <Navigate to="/" replace /> : <LoginPage onLogin={handleLogin} />} />
                            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                            <Route path="/change-password" element={<ChangePasswordPage />} />
                             <Route path="/api-doc" element={<ApiDocsSection />} /> 
                            <Route path="/downloads" element={<ProtectedRoute><DownloadsPage /></ProtectedRoute>} />
                            <Route path="/otp-verification" element={<OtpVerificationPage />} />
                            <Route
                                path="/"
                                element={
                                    <ProtectedRoute>
                                        <OfferPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/config"
                                element={
                                    <ProtectedRoute>
                                        <ConfigPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/locations" element={<ProtectedRoute><LocationsPage /></ProtectedRoute>} />
                            <Route path="/create-receipt" element={<ProtectedRoute><DynamicFormPage /></ProtectedRoute>} />
                            <Route path="/manage-receipts" element={<ProtectedRoute><ManageReceipts /></ProtectedRoute>} />


                            <Route path="*" element={<Typography variant="h4" align="center" mt={5}>404 - Page Not Found</Typography>} />
                        </Routes>
                    </Box>
                </Box>
            )}
        </Router>
    );
}

export default App;